import React, { FC, TouchEvent, useEffect, useState } from 'react';
import SquareContents from '../game/SquareContents';
import Row from './Row';

interface BoardProps {
    contents: SquareContents[][];
    omd: Function;
    omu: Function;
    omo: Function;
    otm: Function;
    ote: Function;
    wordScore?: number;
}


const Board: FC<BoardProps> = ({ contents, omd, omu, omo, otm, ote, wordScore, children }) => {
    const [showWordScore, setShowWordScore] = useState(false);

    useEffect(() => {
        if(wordScore === undefined) {
            setShowWordScore(false);
            return;
        }
        setShowWordScore(true);
        setTimeout(() => setShowWordScore(false), 1000);
    },[wordScore]);

    let rowArray: any = [];

    for (var i = 0; i < contents.length; i++)
        rowArray.push(
            <Row key={'row' + i} contents={contents[i]} x={i} omd={omd} omo={omo} omu={omu} ote={ote} />
        );

    return (
        <div className="BoardContainer">
            <div className="Board"
                onTouchMove={(e: TouchEvent<HTMLDivElement>) => touchHandler(e)}
            >
            {showWordScore && <div className="wordScore">{wordScore}</div>}
                {rowArray}
            </div>
        </div>
    );

    function touchHandler(e: TouchEvent<HTMLDivElement>) {
        let touch = e.touches[0];
        if (!touch) {
            return;
        }
        let div = document.elementFromPoint(touch.clientX, touch.clientY);
        if (div && div.getAttribute('data-x')) {
            otm(+(div.getAttribute('data-x') ?? 0), +(div.getAttribute('data-y') ?? 0));
        }
    }

};

export default Board;
